<template>
  <v-layout justify-center align-center column>

    <input v-if="multiple" :id="`${filename}`" type="file" @change="onChange" multiple hidden ref="input" accept="application/pdf,image/*"/>
    <input v-else :id="`${filename}`" type="file" @change="onChange" hidden ref="input" accept="application/pdf,image/*"/>

    <v-layout row>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn fab color="primary" large @click="dispatchInput" v-on="on">
            <v-icon>attachment</v-icon>
          </v-btn>
        </template>
        <span>{{ buttonLabel }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn fab color="primary" large @click="downloadFilesFromUrl" v-if="hasFiles" v-on="on">
            <v-icon>cloud_download</v-icon>
          </v-btn>
        </template>
        <span>Baixar / Download</span>
      </v-tooltip>
    </v-layout>

  </v-layout>
</template>

<script>
/**
 * @group Input
 * Componente responsável pela seleção de imagens transformação em Base64
 */

const MAXIMUM_FILE_SIZE = 5242880

export default {
  name: 'InputFile',

  props: {
    multiple: {
      type: Boolean,
      required: false
    },

    filename: {
      type: String,
      required: true
    },

    files: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    hasFiles () {
      return this.files.length
    },

    buttonLabel () {
      return this.hasFiles ? 'Alterar registro' : 'Adicionar registro'
    }
  },

  methods: {
    // @vuese Método responsável pelo evento de imagem
    async onChange (fileEvent) {
      let reads = []
      let invalid = false

      const files = fileEvent.target.files

      Object.keys(files).forEach((key, index) => {
        if (files[key].size >= MAXIMUM_FILE_SIZE) {
          this.$emit('error', 'O arquivo não deve ter mais do que 5mb de dados.')
          invalid = true
        } else {
          reads.push(files[key])
        }
      })

      if (!invalid) this.$emit('files', { filename: this.filename, files: reads, multiple: this.multiple })
    },

    // @vuese Método para download dos arquivos
    downloadFilesFromUrl () {
      this.files.map((fileUrl, index) => {
        setTimeout(() => { window.open(fileUrl, '_blank') }, index * 100)
      })
    },

    dispatchInput () {
      this.$refs.input.click()
    }
  }
}
</script>
